export enum Permissions {
  SUPPORT = 'isSupport',
}